import { render } from "./AppointmentCalendar.vue?vue&type=template&id=390b27eb&scoped=true"
import script from "./AppointmentCalendar.vue?vue&type=script&lang=js"
export * from "./AppointmentCalendar.vue?vue&type=script&lang=js"

import "./AppointmentCalendar.vue?vue&type=style&index=0&id=390b27eb&scoped=true&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390b27eb"]])

export default __exports__